import { storageKey } from '@/shared/lib/storage-key';

// Key used before the multi-app split. Kept readable so a rollback still finds
// the session; `clearToken` removes it on the next logout.
const LEGACY_TOKEN_KEY = 'token';

const tokenKey = () => storageKey('token');

export const getToken = (): string | null => {
  try {
    return localStorage.getItem(tokenKey());
  } catch {
    return null;
  }
};

export const setToken = (token: string): void => {
  try {
    localStorage.setItem(tokenKey(), token);
  } catch {
    // localStorage may be unavailable (Safari private mode, etc.). The Redux
    // copy of the token still drives the current session.
  }
};

export const clearToken = (): void => {
  try {
    localStorage.removeItem(tokenKey());
    localStorage.removeItem(LEGACY_TOKEN_KEY);
  } catch {
    // noop
  }
};

/**
 * One-shot migration from the unprefixed `token` key. Runs at bootstrap so
 * sessions opened before the multi-app split survive the deploy.
 */
export const migrateLegacyStorageKeys = (): void => {
  try {
    const legacy = localStorage.getItem(LEGACY_TOKEN_KEY);
    if (legacy && !localStorage.getItem(tokenKey())) {
      localStorage.setItem(tokenKey(), legacy);
    }
  } catch {
    // noop
  }
};
